import styles from "./Home.module.css";
import Text from "../../components/Text/Text.jsx";
import Hero from "../../components/Hero/Hero.jsx";
import Karussell from "../../components/Karussell/Karussell.jsx";
import Spacer from "../../components/Spacer/Spacer.jsx";
import Angebote from "../../components/Angebote/Angebote.jsx";
import Galerie from "../../components/Galerie/Galerie.jsx";
import Impression from "../../components/Impressionen/Impression.jsx";
import Splitter from "../../components/Splitter/Splitter.jsx";

import Location from "../../assets/images/Home/location.avif";

function Home() {
  return (
    <div className={styles.homeContainer}>
      <Hero />
      <Spacer space={"70px"} />
      <Text
        title="Wer wir sind"
        body="Bei Wedding Cuisine dreht sich alles um die Liebe – zum Detail, zum Geschmack und zu unvergesslichen Momenten."
      />
      <Text body="Wir sind ein erfahrenes Catering-Team mit Wurzeln in der Gastronomie und einer großen Leidenschaft für stilvolle Hochzeiten. Unser Anspruch ist es, jede Feier zu einem einzigartigen Genusserlebnis zu machen – mit feinen Menüs, durchdachten Kompositionen und einem Service, der so herzlich ist wie eine gute Umarmung." />
      <Text body="Ob mediterran, klassisch-europäisch oder modern interpretiert: Wir gestalten jedes Menü individuell – passend zu eurem Stil, euren Wünschen, eurem Budget und der besonderen Atmosphäre eures großen Tages." />
      <Text body="Wedding Cuisine steht für Hochzeitscatering mit Seele. Für Menschen, die mehr als „nur essen“ wollen. Für Paare, die genießen wollen – mit allen Sinnen." />
      <Spacer space={"80px"} />
      <Karussell />
      <div id="card-menu"></div> {/* Für die Ankerlinks */}
      <Spacer space={"70px"} />
      <Text
        title="Unsere Angebote"
        body="Exotische Genüsse oder moderne Klassiker – unsere Catering-Menüs bringen die Geschmäcker der Welt auf euren Tisch. Jedes Angebot ist mit viel Liebe zum Detail zusammengestellt und lässt sich individuell anpassen. Am Tisch serviert, als Buffet, oder mit einem unserer Foodtrucks. Ihr habt die Wahl!"
      />
      <Spacer space={"70px"} />
      <Angebote />
      <Spacer space={"85px"} />
      <Galerie />
      <Spacer space={"70px"} />
      <Splitter
        image={Location}
        children={
          <Text
            preheader="Euer Fest beginnt mit dem richtigen Ort"
            title="Besondere Locations für besondere Anlässe"
            body="Von stilvollen Hochzeiten über Business-Events bis hin zu privaten Feiern im kleinen Kreis: Unsere Event-Locations bieten flexible Raumkonzepte, besondere Atmosphäre und den passenden Rahmen für euer individuelles Catering-Erlebnis."
          />
        }
        hasButton
        buttonText="Zu den Locations"
        nav="/locations"
      />
      <div id="card-impression"></div> {/* Für die Ankerlinks */}
      <Spacer space={"100px"} />
      <Text
        title="Echte Stimmen, echte Erlebnisse."
        body="Unsere Gäste stehen im Mittelpunkt – und ihre Begeisterung spricht für sich. Hier teilen sie ihre Eindrücke von unseren kulinarischen Erlebnissen."
      />
      <Spacer space={"70px"} />
      <Impression />
      <Spacer space={"90px"} />
    </div>
  );
}

export default Home;
